module.exports = __webpack_public_path__ + "static/media/[Keats_and_Beats]2014-04-16.325e6d48.md";